import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../common/axios";
import useGet from "../../hooks/useGet";
import { getErrors, hasData, toastDefault } from "../../utils/handler.utils";
import { spinTableColumns } from "../../utils/reactTableColumns";
import ReactTable from "../ReactTables/ReactTable";
import UiHandler from "../UiHandler";

function Spin() {
  const [uniqueState, setUniqueState] = useState(false);
  const [spinData, loading, error] = useGet("admin/spins", "", uniqueState);

  const deleteSpinHandler = (id) => {
    if (window.confirm("Are you sure")) {
      toast.promise(
        axiosInstance.post(`admin/spin/delete/${id}`),
        {
          pending: "Deleting spin...",
          error: {
            render(err) {
              console.log(err);
              return getErrors(err.data, false, true);
            },
          },
          success: {
            render() {
              setUniqueState((prev) => !prev);
              return "Spin deleted successfully";
            },
          },
        },
        toastDefault
      );
    }
  };

  const editButton = {
    id: "action",
    Header: "Action",
    accessor: "id",
    Cell: (e) => {
      return (
        <ul className="flex space-x-2">
          <Link to={`/spin/edit/${e.value}`} className="cstm_btn_small">
            Edit
          </Link>
          <button
            className="cstm_btn_small !bg-red-600 hover:!bg-red-700"
            type="button"
            onClick={() => deleteSpinHandler(e.value)}
          >
            Delete
          </button>
        </ul>
      );
    },
  };

  const withEditButton = [...spinTableColumns, editButton];

  return (
    <section className="relative container_admin">
      <div className="bg-white overflow-hidden rounded">
        <div className="px-6 py-3 border-b border-gray-200 flex items-center justify-between flex-wrap">
          <h3 className="text-lg font-bold text-black">Spins</h3>
          <Link className="cstm_btn" to="/spin/add">
            Add new
          </Link>
        </div>
        <div>
          <div className="relative min-h-[100px]">
            <UiHandler data={spinData} loading={loading} error={error} />
            {hasData(spinData, error) && (
              <ReactTable
                tableId="spin_table"
                columns={withEditButton}
                data={spinData}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Spin;
